/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:37:23                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 15:52:53                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * AdminInterventionsTab: Admin interventions tab
*/

/* Imports */
import { useCallback, useEffect, useState } from "react";
/***/

/* Services */
import Loading from "../../../../../../components/loading/Loading";
import { Table } from "../../../../../../components/table/Table";
import { createListQuery, searchWithFilters } from "../../../../../../services/api/search";
import { api } from "../../../../../../services/api/api";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import ZoneForm from "../../../../../../components/data/zone/ZoneForm";
import ZoneListItem from "../../../../../../components/data/zone/ZoneListItem";
import { Button } from "@material-tailwind/react";
/***/

/**
* AdminInterventionsTab: Admin interventions tab
*/
export default function AdminZonesTab() {
  const [zones, setZones] = useState<EasyTech.Zone[] | null>(null);

  const [synchroLoad, setSynchroLoad] = useState<boolean>(false);

  const TABLE_HEAD = [
    {
      label: "Address",
      orderKey: "address"
    },{
      label: "Radius",
      orderKey: "radius"
    },{
      label: "Type",
      orderKey: "type"
    },{
      label: "Enabled",
      orderKey: "enabled"
    }, {
      label: "actions",
      orderKey: null
    }
  ];
  
  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const createZone = (zone: EasyTech.Zone): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (zone.type === "B" || (zone.address && zone.radius && zone.type)) {
        api.post("admin/zones", zone).then((ret) => {
          loadZones();
          toast.success("Zone created");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la création de la zone" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  const loadZones= useCallback(() => {
    searchWithFilters<EasyTech.Zone>("zones", {
      queries: [createListQuery("enabled", [true, false], "IN")]
    }, true, true)
      .then(ret => setZones(ret.data as EasyTech.Zone[]))
      .catch(err => {
        console.error(err);
        setZones([]);
      });
  }, []);
  
  const synchroZone = () => {
    setSynchroLoad(true);
    api.get("admin/workorders/synchro-work-orders-zones")
      .then(() => {
        setSynchroLoad(false);
      });
  };

  /**
  * useEffect: get interventions list 
  * on init
  */
  useEffect(() => {
    loadZones();
  }, [loadZones]);
  /***/

  return (
    <div>
      <div className="icon-buttons flex gap-2">
        <EditCreateDrawer entityName="Zone"
                          FormComponent={ZoneForm}
                          isNotEditable={true}
                          onSubmit={createZone}
                          createButtonText="Create new Zone" />
        <Button onClick={synchroZone}>
          {synchroLoad ?
            <Loading/>
            :
            "Apply zone on old interventions"
          }
        </Button>
      </div>

      <div className="my-6">
        {zones ?
          <Table  tableHead={TABLE_HEAD}
                  emptyTable={(!zones || zones.length === 0) ? "No zones" : false}>
            {zones.map((zone, index) => (
              <ZoneListItem key={"zonelistitem-"+index} zone={zone} isLast={index === zones.length - 1} onChange={loadZones} />
            ))}
          </Table>
        : <Loading/>}
      </div>
      
    </div>
  );
}
/***/
